import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { formatDashDate } from '@ifca-root/react-component/src/helpers/StringNumberFunction/formatDate'
import {
  IconButton,
  ListItem,
  Menu,
  MenuItem,
  Switch,
  TextField,
} from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import AddBoxIcon from '@material-ui/icons/AddBox'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import { AccountFooter } from 'components/Footer/AccountFooter'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import { format } from 'date-fns'
import {
  useCreateCommonTaxSchemeMutation,
  useGetTaxListingQuery,
  useGetTaxSchemeTypeListingQuery,
  useUpdateCommonTaxSchemeMutation,
} from 'generated/graphql'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { toProperCase } from 'helpers/StringNumberFunction/StringConverter'
import React, { useContext, useEffect, useState } from 'react'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { useHistory, useLocation, useParams } from 'react-router'
import { v4 as itemuuid } from 'uuid'
import { TaxSchemeDialog } from './TaxSchemeDialog'

interface TaxSchemeFormProps {
  Name: string
  Description: string
  IsExclusive: boolean
  TaxSchemeDetail: any[]
}

export const TaxSchemeForm = props => {
  const location = useLocation()
  const { TaxSchemeID }: any = useParams()
  const { mode } = props
  const editData: any = location?.state
  const history = useHistory()
  const [openExitConf, setOpenExitConf] = useState(null)
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(SnackBarContext)
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const [IsExclusive, setIsExclusive] = useState(
    editData ? editData?.isExclusive : false
  )
  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const [detailMode, setDetailMode] = useState<string>(
    TaxSchemeID ? 'edit' : 'add'
  )
  const [mountDialog, setMountDialog] = useState<boolean>(false)
  const [detailIndex, setDetailIndex] = useState<number>(0)
  const [inputOrOutput, setInputOrOutput] = useState<'INPUT' | 'OUTPUT'>(
    'OUTPUT'
  )
  const [reqToDeleteTaxSchemeDtl, setReqToDeleteTaxSchemeDtl] = useState([])

  const [isExemptedScheme, setIsExemptedScheme] = useState<boolean>(
    !!editData?.isExemptedTaxScheme
  )

  // For Tax Scheme Dialog
  const [items, setItems] = useState(
    detailMode === 'add'
      ? [
          {
            detailItemId: itemuuid(),
            selectedTax: null,
            computeMethod: 'TAX_ON_GROSS',
            taxOnSeq: [],
            seqNo: 1,
          },
        ]
      : []
  )

  const flexRowStyle = {
    display: 'flex' as any,
    flexDirection: 'row' as any,
    justifyContent: 'space-between' as any,
    width: '100%' as any,
  }

  /* -------------------------------------------- */
  /*              QUERIES / MUTATIONS             */
  /* -------------------------------------------- */

  const {
    loading: TaxListingLoading,
    data: { getTaxListing } = {
      getTaxListing: [],
    },
  } = useGetTaxListingQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getTaxListing }) => {
      if (mode === 'edit') {
        let taxSchemeDetails: any[] = []

        editData?.taxSchemeDetailList?.forEach(detail => {
          let taxSchemeDetailItem: any[] = []

          for (
            let index = 0;
            index < detail?.taxSchemeDetailItemList.length;
            index++
          ) {
            const item = detail?.taxSchemeDetailItemList[index]
            setInputOrOutput(
              getTaxListing?.find(x => x?.tax_id === item?.taxId)?.class_type
            )
            taxSchemeDetailItem.push({
              detailItemId: item?.id,
              taxId: item?.taxId,
              computeMethod: item?.computeMethod,
              taxOnSeq: item?.taxOnSeq?.map(a => {
                return {
                  seqNo: a?.seqNo,
                  taxSchemeDetailItemId: a?.taxSchemeDetailItemId,
                }
              }),
              seqNo: item?.seqNo,
            })
          }

          taxSchemeDetails?.push({
            detailId: detail?.id,
            effectiveDate: detail?.effectiveDate,
            taxSchemeDetailItem,
          })
        })

        prepend(taxSchemeDetails)
      }
    },
  })

  const {
    loading: TaxSchemeTypeLoading,
    data: { getTaxSchemeTypeListing } = {
      getTaxSchemeTypeListing: [],
    },
  } = useGetTaxSchemeTypeListingQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const [createTaxScheme, { loading: CreateTaxSchemeLoading }] =
    useCreateCommonTaxSchemeMutation({
      onError: ({ message }) => {
        let error = message?.substring(15)
        setErrMessage(error)
        setErrDialog(true)
      },
      onCompleted: () => {
        setOpenSnackBar(true)
        setSnackBarMsg(SystemMsgs.createNewRecord())
        setTimeout(() => {
          history.push({
            pathname: `/common-setting/tax-scheme`,
            state: { success: true, msgMode: 'create' },
          })
        }, 500)
      },
    })

  const [updateTaxScheme, { loading: UpdateTaxSchemeLoading }] =
    useUpdateCommonTaxSchemeMutation({
      onError: ({ message }) => {
        let error = message?.substring(15)
        setErrMessage(error)
        setErrDialog(true)
      },
      onCompleted: () => {
        setOpenSnackBar(true)
        setSnackBarMsg(SystemMsgs.createNewRecord())
        setTimeout(() => {
          history.push({
            pathname: `/common-setting/tax-scheme`,
            state: { success: true, msgMode: 'create' },
          })
        }, 500)
      },
    })

  const { handleSubmit, register, errors, control, setValue, watch } =
    useForm<TaxSchemeFormProps>({
      defaultValues: {
        Name: mode === 'add' ? '' : editData?.name,
        Description: mode === 'add' ? '' : editData?.description,
        IsExclusive: mode === 'add' ? false : editData?.isExclusive,
        TaxSchemeDetail: mode === 'edit' ? editData?.taxSchemeDetail || [] : [],
      },
      mode: 'onSubmit',
    })

  const { fields, append, remove, prepend } = useFieldArray({
    control,
    name: 'TaxSchemeDetail',
  })

  useEffect(() => {
    if ((mode === 'edit' && fields?.length > 0) || mode === 'add') {
      setMountDialog(true)
    }
  }, [mode, fields])

  const hasChanges = () => {
    const hasInfo =
      (watch('Name') !== '' && watch('Name') !== undefined) ||
      (watch('Description') !== '' && watch('Description') !== undefined) ||
      watch('IsExclusive') !== undefined

    const prevData = {
      Name: editData?.name,
      Description: editData?.description,
      IsExclusive: editData?.isExclusive,
    }

    const currentData = {
      Name: watch('Name'),
      Description: watch('Description'),
      IsExclusive: watch('IsExclusive'),
    }

    if (mode === 'edit') {
      return JSON.stringify(prevData) !== JSON.stringify(currentData)
    } else {
      return hasInfo
    }
  }

  const { anchorEl, menu, handleClick, handleClose } = useMenuOption()

  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  const handleIsExclusiveToggle = e => {
    setValue('IsExclusive', e.target.checked)
    setIsExclusive(e.target.checked)
  }

  const handleIsInput = e => {
    remove()
    setItems([])
    setInputOrOutput(e.target.checked ? 'INPUT' : 'OUTPUT')
  }

  // const handleExemptedToggleChange = e => {
  //   remove()
  //   setItems([])
  //   setIsExemptedScheme(e.target.checked)
  // }

  const disallowAddDetail = () => {
    return !!fields?.find(
      x =>
        formatDashDate(new Date(x?.effectiveDate).toISOString()) >=
        formatDashDate(
          new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString()
        )
    )
  }

  const disableEffectiveDetail = date => {
    return !!(
      new Date(new Date(date).setHours(0, 0, 0, 0)) <
      new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000)
    )
  }

  const onClickEdit = () => {
    setDetailMode('edit')
    setOpenDialog(true)

    let tempItems: any[] = []

    for (let x = 0; x < fields[detailIndex]?.taxSchemeDetailItem.length; x++) {
      const curr = fields[detailIndex]?.taxSchemeDetailItem[x]

      tempItems?.push({
        computeMethod: curr?.computeMethod,
        detailItemId: curr?.detailItemId,
        selectedTax: getTaxListing?.find(x => x?.tax_id === curr?.taxId),
        seqNo: curr?.seqNo,
        taxOnSeq: curr?.taxOnSeq ? curr?.taxOnSeq?.map(tsq => tsq?.seqNo) : [],
      })
    }

    setItems(tempItems)
  }

  const onSubmit = data => {
    let taxSchemeDetailArray: any[] = []

    for (let index = 0; index < fields?.length; index++) {
      taxSchemeDetailArray.push({
        detailId: fields[index]?.detailId,
        effectiveDate: fields[index]?.effectiveDate,
        taxSchemeDetailItem: fields[index]?.taxSchemeDetailItem,
      })
    }

    let input = {
      ...(mode === 'edit' && { id: TaxSchemeID, reqToDeleteTaxSchemeDtl }),
      name: data?.Name,
      description: data?.Description,
      isExclusive: data?.IsExclusive,
      createdBy: user?.ID,
      modBy: user?.ID,
      taxSchemeDetail: taxSchemeDetailArray,
    }
    if (mode === 'add') {
      createTaxScheme({ variables: { input } })
    } else {
      updateTaxScheme({ variables: { input } })
    }
  }

  const enumFormatter = (str: string) => {
    return ` ${str
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
      .join(' ')}`
  }

  return (
    <>
      {TaxListingLoading && <Loading />}
      {TaxSchemeTypeLoading && <Loading />}
      {CreateTaxSchemeLoading && <Loading />}
      {UpdateTaxSchemeLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => {
          hasChanges()
            ? setOpenExitConf(true)
            : history.push(`/common-setting/tax-scheme/`)
        }}
        smTitle="Common Settings"
        title={user?.accountName}
        routeSegments={[
          { name: 'Common Setting' },
          { name: 'Tax Scheme', current: true },
        ]}
        rightRouteSegments={[
          { name: mode === 'add' ? 'New' : 'Edit', current: true },
        ]}
      />
      <ContentWrapper float>
        <CardContents section={{ header: { title: 'Tax Scheme' } }}>
          <Controller
            as={TextField}
            name="Name"
            control={control}
            label="Name"
            margin="normal"
            autoComplete="off"
            required
            helperText={errors?.Name?.message}
            error={!!errors?.Name}
          />
          <Controller
            as={TextField}
            name="Description"
            control={control}
            label="Description"
            margin="normal"
            autoComplete="off"
            required
            helperText={errors?.Description?.message}
            error={!!errors?.Description}
          />
          <div
            className="content-wrap full"
            style={{
              justifyContent: 'space-between',
              display: 'flex',
            }}
          >
            <span className="flex-space" style={{ alignContent: 'center' }}>
              Exclusive Tax
            </span>
            <Switch
              name="IsExclusive"
              color="primary"
              inputRef={register()}
              //checked={isExemptedScheme ? true : IsExclusive}
              checked={IsExclusive}
              onChange={handleIsExclusiveToggle}
              //disabled={!!isExemptedScheme}
            />
          </div>
          <div
            className="content-wrap full"
            style={{
              justifyContent: 'space-between',
              display: 'flex',
            }}
          >
            <span className="flex-space" style={{ alignContent: 'center' }}>
              {`Tax Mode: ${toProperCase(inputOrOutput)}`}
            </span>
            <Switch
              name="IsInput"
              color="primary"
              checked={!!(inputOrOutput === 'INPUT')}
              onChange={handleIsInput}
              disabled={
                fields?.length > 0 &&
                disableEffectiveDetail(fields[0]?.effectiveDate) === true
              }
            />
          </div>
          {/* <div
            className="content-wrap full"
            style={{
              justifyContent: 'space-between',
              display: 'flex',
            }}
          >
            <span className="flex-space" style={{ alignContent: 'center' }}>
              {`Exempted Tax code Only `}
            </span>
            <Switch
              name="isExemptedScheme"
              color="primary"
              checked={!!isExemptedScheme}
              onChange={handleExemptedToggleChange}
              disabled={
                fields?.length > 0 &&
                disableEffectiveDetail(fields[0]?.effectiveDate) === true
              }
            />
          </div> */}
        </CardContents>
        <CardContents
          section={{
            header: {
              title: 'Tax Scheme Detail',
              icon: (
                <AddBoxIcon
                  htmlColor="white"
                  fontSize="medium"
                  style={{
                    color: disallowAddDetail() === true ? '#bab3ab' : '#ff9800',
                  }}
                />
              ),
              onClickAction: () => {
                setOpenDialog(true)
                setDetailMode('add')
                setItems([
                  {
                    detailItemId: itemuuid(),
                    selectedTax: null,
                    computeMethod: 'TAX_ON_GROSS',
                    taxOnSeq: [],
                    seqNo: 1,
                  },
                ])
              },
              disabled: disallowAddDetail() === true,
            },
          }}
        >
          {fields.length === 0 ? (
            <div style={{ width: '100%', justifyContent: 'center' }}>
              <EmptyList
                title={'No Records'}
                subtitle={'Click the add button to create a new record.'}
              />
            </div>
          ) : (
            fields
              ?.sort(
                (a, b) =>
                  new Date(a?.effectiveDate).getTime() -
                  new Date(b?.effectiveDate).getTime()
              )
              ?.map((el, index) => (
                <ListItem
                  style={{
                    padding: '0',
                    display: 'block',
                    borderBottom:
                      index !== fields?.length - 1 && '0.5px solid #212121',
                  }}
                >
                  <div style={flexRowStyle}>
                    <span className="desc" style={{ alignContent: 'center' }}>
                      {format(new Date(el?.effectiveDate), 'dd MMM yyyy')}
                    </span>
                    {disableEffectiveDetail(el?.effectiveDate) === false && (
                      <IconButton
                        edge="end"
                        aria-controls="menu-list"
                        aria-haspopup="true"
                        onClick={e => {
                          handleClick(e, el?.id, index, el)
                          setDetailIndex(index)
                        }}
                      >
                        <MoreVert />
                      </IconButton>
                    )}
                  </div>
                  {el?.taxSchemeDetailItem?.map((inel, inindex) => (
                    <ListItem className="desc" style={{ display: 'block' }}>
                      <div style={flexRowStyle}>
                        <span>
                          {inindex + 1}
                          .&nbsp;
                          {`${
                            getTaxListing?.find(x => x?.tax_id === inel?.taxId)
                              ?.code
                          } ${
                            getTaxListing?.find(x => x?.tax_id === inel?.taxId)
                              ?.rate
                          }%`}
                        </span>
                        <span>
                          {
                            getTaxSchemeTypeListing?.find(
                              x =>
                                x?.id ===
                                getTaxListing?.find(
                                  x => x?.tax_id === inel?.taxId
                                )?.scheme_type_id
                            )?.name
                          }
                        </span>
                      </div>
                      <div style={flexRowStyle}>
                        <span>{`${enumFormatter(inel?.computeMethod)}`}</span>
                        <span>
                          {
                            getTaxListing?.find(x => x?.tax_id === inel?.taxId)
                              ?.class_type
                          }
                        </span>
                      </div>
                      <div style={flexRowStyle}>
                        <span>{`${
                          getTaxListing?.find(x => x?.tax_id === inel?.taxId)
                            ?.MasterCOA?.Code ?? 'N/A'
                        } || ${
                          getTaxListing?.find(x => x?.tax_id === inel?.taxId)
                            ?.MasterCOA?.Name ?? 'N/A'
                        }`}</span>
                      </div>
                    </ListItem>
                  ))}
                </ListItem>
              ))
          )}
        </CardContents>
      </ContentWrapper>
      <Menu
        id="menu-list"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <MenuItem onClick={onClickEdit}>
          <span>Edit</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            remove(menu?.index)
            reqToDeleteTaxSchemeDtl.push(menu?.obj?.id)
          }}
        >
          <span>Delete</span>
        </MenuItem>
      </Menu>
      <AccountFooter
        options={[
          {
            name: 'Save',
            type: 'submit',
            color: 'primary',
            onClick: () => handleSubmit(onSubmit)(),
            disabled: !!(fields?.length === 0),
          },
        ]}
      />
      {mountDialog === true && (
        <TaxSchemeDialog
          open={openDialog}
          onClose={() => {
            setOpenDialog(false)
            setItems([])
          }}
          items={items}
          setItems={setItems}
          detailMode={detailMode}
          fields={fields}
          append={append}
          detailIndex={detailIndex}
          getTaxListing={getTaxListing?.filter(
            x => x?.tax_status === 'ACTIVE' && x?.class_type === inputOrOutput
          )}
          isExemptedScheme={isExemptedScheme}
        />
      )}
      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(`/common-setting/tax-scheme/`)
        }}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
